export default __webpack_public_path__ + "static/media/default_avatar.97c59006.svg";